export function diffBetweenDays(date1: Date, date2: Date): number {

  // Get the time difference in milliseconds
  const timeDiff = Math.abs(date2.getTime() - date1.getTime());
  
  // Convert the time difference from milliseconds to days
  const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
  
  return diffDays;
}

export function addDaysToDate(date: Date, days: number): Date {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}